import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import Button from 'fe-design-base/molecules/Button';
import List from 'fe-design-base/molecules/List';

import { toI18n } from 'util/i18n';

interface BundleViewProps {
  onClick: () => void;
}

const BundleView = ({ onClick }: BundleViewProps) => {
  const history = useHistory();

  const handleViewPlans = useCallback(() => {
    history.push('/manage_plans');
    onClick();
  }, [history, onClick]);

  return (
    <Box borderbox column alignItemsStart justifyContentSpaceBetween p={30}>
      <Box column gap={24}>
        {/* Header */}
        <Box mb={12}>
          <Text
            variant="heading3"
            color="mono900"
            i18n="paywalls.modal.bundle.title"
          />
        </Box>

        {/* Tier Benefits */}
        <Box column gap={16}>
          <Box>
            <Text
              variant="heading4"
              color="mono900"
              i18n="paywalls.modal.bundle.subtitle"
            />
          </Box>

          <Box>
            <List
              size="small"
              variant="check"
              gapOverride="8px"
              data={[
                {
                  primary: toI18n('paywalls.modal.bundle.features.track_hours'),
                },
                {
                  primary: toI18n(
                    'paywalls.modal.bundle.features.cut_time_theft'
                  ),
                },
                {
                  primary: toI18n(
                    'paywalls.modal.bundle.features.sync_hours_and_tips'
                  ),
                },
              ]}
            />
          </Box>
        </Box>
      </Box>

      {/* Action Buttons */}
      <Box w="100%" alignItemsCenter justifyContentEnd gap={8}>
        <Button
          variant="primary"
          onClick={handleViewPlans}
          uxElement="view_plan_details"
        >
          {toI18n('paywalls.modal.bundle.cta')}
        </Button>
      </Box>
    </Box>
  );
};

export default BundleView;
